import { LogoInnovatrics, Translate } from '..'
import { Grid, Link, Typography, useMediaQuery } from '@mui/material'

export const PrivacyPolicy = () => {
  const matches = useMediaQuery('(min-width:750px)')
  return (
    <Grid container flexDirection={'column'}>
      <Grid item sx={{ background: '#F2F3F4' }}>
        <Grid
          container
          justifyContent={'center'}
          alignItems={'center'}
          wrap={'nowrap'}
          maxWidth={'1200px'}
          marginX={'auto'}
        >
          <Grid item>
            <Typography
              color={'secondary'}
              maxHeight={'36px'}
              fontSize={'24px'}
              fontWeight={400}
              marginY={'25px'}
              textAlign={'center'}
            >
              <Translate
                entityName={'customer.privacy.title'}
                defaultMessage={'Privacy policy'}
              />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        flexDirection={'column'}
        maxWidth={matches ? '1200px' : 'calc(100vw - 35px)'}
        rowSpacing={'30px'}
        margin={'0 auto'}
        paddingBottom={'30px'}
        minHeight={matches ? 'calc(100vh - 192px)' : 'calc(100vh - 226px)'}
      >
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.personalData.title'}
              defaultMessage={'PERSONAL DATA PROTECTION POLICY'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.personalData.text'}
              defaultMessage={
                'Innovatrics, s.r.o. has developed this Personal Data Protection Policy (“Policy”) to demonstrate our commitment to protect our user’s privacy. The terms “Innovatrics”, “we”, “us” and “our” include Innovatrics, s.r.o. and any subsidiaries. The terms “you” and “your” refer to any individuals and entities who use or visit our services or website, such as Digital onboarding toolkit demo or any other demo web and/or mobile app (later in the policy referred as “Our Services”). Protection of your personal data is essential for us with regard to the adoption of the Regulation of the European Parliament and of the Council (EU) 2016/678 of 27 April 2016 on the protection of natural persons in the processing of personal data and on the free movement of such data, repealing Directive 95/46/EC (“GDPR”), we adopt this personal data protection policy. This policy describes our practices, information we collect, how we use that information, with whom your information are or will be shared.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.1.title'}
              defaultMessage={'1. THE CONTROLLER AND ITS CONTACT INFORMATION'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.1.text.1'}
              defaultMessage={
                'The Controller is Innovatrics, s.r.o. , with its registered seat at: Pri Vinohradoch 82, 831 06 Bratislava, Slovak Republic, ID No: 36 280 712, registered in the Commercial Register of District Court Bratislava I, Section: Sro, File No. 39481/B.<br><br>If you want to communicate with us about personal data protection issues, please use the following contacts: e-mail:'
              }
            />{' '}
            <Link href="mailto:info@innovatrics.com">info@innovatrics.com</Link>{' '}
            <Translate
              entityName={'customer.privacy.1.text.2'}
              defaultMessage={
                'or contact us on our address: Innovatrics, s.r.o., Jarošova 1, 831 03 Braislava, Slovak Republic.<br><br>Innovatrics will address your concerns and attempt to resolve any privacy issues in a timely manner.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.2.title'}
              defaultMessage={
                '2. HOW YOUR PERSONAL DATA ARE PROCESSED AND USED'
              }
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.2.text'}
              defaultMessage={
                'You may provide your consent to provide your Personal information directly to Innovatrics through ticking the box on our services.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
          >
            <Translate
              entityName={'customer.privacy.2.1.title'}
              defaultMessage={'2.1 We collect these categories of data:'}
            />
          </Typography>
          <ul
            style={{
              paddingLeft: '22px',
              listStyleType: 'dot',
              color: '#021B41',
            }}
          >
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.1.list.1'}
                  defaultMessage={
                    '<b>User data</b> – Scan of an ID Card (National ID card, passport, driving license, etc.) with the information depending on the card, typically for example: Name, Surname, Nationality, Sex, ID Number, Date of Birth, Personal No., Date of issue, Date of Expiration, Address, Place of birth, Surname at birth, photo. In the future, location data may be collected if needed for our purposes.'
                  }
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.1.list.2'}
                  defaultMessage={
                    '<b>Device data</b> – recognizing whether our services were accessed via phone or personal computer.'
                  }
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.1.list.3'}
                  defaultMessage={
                    '<b>Special category</b> – Nationality and biometric data as face recognition for the purposes of uniquely identifying a natural person.'
                  }
                />
              </Typography>
            </li>
          </ul>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'25px'}
          >
            <Translate
              entityName={'customer.privacy.2.1.text'}
              defaultMessage={
                'We are not using Nationality for our<br>Main – research and development – improvement of our image processing technologies.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
          >
            <Translate
              entityName={'customer.privacy.2.2.title'}
              defaultMessage={
                '2.2 The personal data we collect will be used for the following purposes:'
              }
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.2.text'}
              defaultMessage={
                'We acquire, hold, used and process Personal Information based on the legal grounds and for legitimate business purposes outlined in this Policy, such as:'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.2.list.administrative.title'}
              defaultMessage={
                '<b>Administrative Purposes</b> – Innovatrics may use your personal information about you for its administrative purposes, including to:'
              }
            />
          </Typography>
          <ul
            style={{
              paddingLeft: '45px',
              listStyleType: 'dot',
              color: '#021B41',
            }}
          >
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.1'}
                  defaultMessage={
                    'Protect the security of our Service and Website and to prevent fraud,'
                  }
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.2'}
                  defaultMessage={
                    'To provide Services or Information requested,'
                  }
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.3'}
                  defaultMessage={'Develop new Services,'}
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.4'}
                  defaultMessage={'Ensure internal quality control,'}
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.5'}
                  defaultMessage={'Verify individual identity,'}
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.6'}
                  defaultMessage={'Process transactions,'}
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.7'}
                  defaultMessage={'Process transactions,'}
                />
              </Typography>
            </li>
            <li>
              <Typography
                color={'secondary'}
                fontSize={'16px'}
                lineHeight={'26px'}
                fontWeight={400}
              >
                <Translate
                  entityName={'customer.privacy.2.2.list.administrative.item.8'}
                  defaultMessage={'Enforce our terms of use.'}
                />
              </Typography>
            </li>
          </ul>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.2.list.research'}
              defaultMessage={
                '<b>Research and Development:</b> Innovatrics as biometric technology provider collect personal data and use them for research and development in order to improve our image processing technologies and/or to develop new lines of services or technologies.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
          >
            <Translate
              entityName={'customer.privacy.2.3.title'}
              defaultMessage={'2.3 Consent'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.3.text'}
              defaultMessage={
                'You may withdraw consent at any time as described in Section 4 below.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
          >
            <Translate
              entityName={'customer.privacy.2.4.title'}
              defaultMessage={'2.4 Disclosure'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.4.text'}
              defaultMessage={
                'Innovatrics, s.r.o. will not pass on your personal data to third parties without first obtaining your consent. Please note that Innovatrics, s.r.o. does not share personal information with third parties for marketing purposes.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
          >
            <Translate
              entityName={'customer.privacy.2.5.title'}
              defaultMessage={'2.5 Data Transfers'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
          >
            <Translate
              entityName={'customer.privacy.2.5.text'}
              defaultMessage={
                'All Personal Information collected via or by Innovatrics may be stored – in the cloud (external providers) and/or on our servers. Your personal information may be accessible to law enforcement or other authorities pursuant to a lawful request. By providing information to Innovatrics, you consent to the storage of your Personal Information in these locations.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.3.title'}
              defaultMessage={'3. COOKIES'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.3.text'}
              defaultMessage={
                'We, on our Services or Website, may use cookies and possibly local storage, mobile device identifiers and other technologies to automatically collect information through the Services or Website.<br><br>Cookies. Cookies are bits of data stored on your Device through your browser or mobile application that allow the mobile application to remember you the next time you visit. Cookies enable smoother, more efficient use of the Website by storing your specific information and preferences such as theme, language setting, privacy preferences, so you do not need to reenter those each time you visit the Website.<br><br></br>Cookies on our services contain the individual app settings data like OCR confidence threshold, face verification threshold, selfie min. and max. eye distance ratio and liveness check steps.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.4.title'}
              defaultMessage={'4. YOUR RIGHTS'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.4.text.1'}
              defaultMessage={
                'As a data subject under the GDPR, you have the right (i) based on a written (including electronic) request to access your personal data (in particular, to require confirmation whether or not the date is being processed, the category of data being processed, the purpose of processing, the source of the data, and the duration of retention); (ii) to repair the incorrect or supplement the incomplete data; (iii) to restrict the processing under the Art.18 of the GDPR (e.g., if the data is incorrect or processed illegally); (iv) to obtain personal data related to you and which you have provided to the Controller in a structured, commonly used and machine readable format, and the right to transfer such data to another controller under the conditions specified in the Art. 20 of the GDPR; (v) to object in the cases referred to in the Art. 21 of the GDPR; (vi) to the erasure of data the purpose of the processing of which has ended or in the cases listed in the Art. 17 of the GDPR.<br><br>You may inquire as to whether Innovatrics is processing personal information about you, request access to Personal Information, and ask that we correct, amend or delete your Personal information by sending us an email to'
              }
            />{' '}
            <Link href="mailto:info@innovatrics.com">info@innovatrics.com</Link>{' '}
            <Translate
              entityName={'customer.privacy.4.text.2'}
              defaultMessage={
                'or use our address specified in the section 1 to contact us via post<br><br>If you believe that your rights are being violated in the processing of personal data or that there is violation of the Personal Data Protection Act or the GDPR, you may file a motion to initiate personal data protection proceeding at the Office for Personal Data Protection of the Slovak Republic, Hraničná 12, 820 07 Bratislava 27, Slovak Republic; www.dataprotection.gov.sk.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.5.title'}
              defaultMessage={'5. SECURITY OF YOUR INFORMATION'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.5.text'}
              defaultMessage={
                'The security of your Personal information is important to us. We maintain appropriate safeguards and current security standards to protect your Personal information from unauthorized access, disclosure, or misuse, such as using SSL encryption. However, no system can be completely secure, and we cannot ensure or warrant the security of any information you provide to us. While we take meaningful steps to secure your information, we do not promise, and you should not expect, that your Personal information will always remain secure. We do not accept liability for unintentional disclosure.<br><br>If we learn of a security system’s breach, we may attempt to notify you electronically by posting a notice on our services.'
              }
            />
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'28px'}
            fontWeight={600}
            textTransform={'uppercase'}
          >
            <Translate
              entityName={'customer.privacy.6.title'}
              defaultMessage={'6. RETENTION'}
            />
          </Typography>
          <Typography
            color={'secondary'}
            fontSize={'16px'}
            lineHeight={'26px'}
            fontWeight={400}
            marginTop={'8px'}
          >
            <Translate
              entityName={'customer.privacy.6.text'}
              defaultMessage={
                'Innovatrics retains the Personal information we receive as described in this Policy for as long as necessary to fulfill the purpose(s) for which it was collected, provide our services, resolve disputes, establish legal defenses, conduct audits, pursue legitimate business purposes, enforce our agreements, and comply with applicable laws.<br><br>* We may change or modify this PERSONAL DATA PROTECTION POLICY at any time, in particular regarding legislative change in the area of personal data proception which may be adopted in the future.'
              }
            />
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
        paddingY={'35px'}
        sx={{ background: '#F2F3F4' }}
      >
        <Typography
          fontSize={'14px'}
          lineHeight={'16px'}
          fontWeight={400}
          marginTop={'8px'}
        >
          <Translate
            entityName={'customer.privacy.footer.text'}
            defaultMessage={'© 2018 Innovatrics. All rights reserved.'}
          />
        </Typography>
        <Grid item sx={{ marginTop: '15px' }}>
          <a href="https://www.innovatrics.com/" target="_blank">
            <LogoInnovatrics />
          </a>
        </Grid>
      </Grid>
    </Grid>
  )
}
